/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} MinuteInputs */



/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count} minute" |
* | "other" | "{count} minutes" |
*
* @param {MinuteInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const minute = /** @type {((inputs: MinuteInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<MinuteInputs, { locale?: "fr" | "en" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") {
		const countPlural = registry.plural("en", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} minute`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} minutes`);
		return /** @type {LocalizedString} */ ("minute");
	}
	{
		const countPlural = registry.plural("fr", i?.count, {}, true);
		if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} minute`);
		if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} minutes`);
		return /** @type {LocalizedString} */ ("minute");
	}
});